<template>
  <v-dialog persistent max-width="500" v-model="show">
    <v-card ref="form" class="pt-7">
      <v-card-text>
        <div class="headline font-weight-bold font--text">Confirm Password</div>
      </v-card-text>
      <v-card-text>
        Confirm Password for Enroll New Multi Factor Authentication 
      </v-card-text>
      <v-card-text class="pb-0">
        <p class="font-weight-bold mb-1">Email</p>
        <v-text-field
          id="email"
          readonly
          v-model="email"
          outlined
          single-line
        ></v-text-field>
      </v-card-text>
      <v-card-text class="pt-0 pb-0">
        <p class="font-weight-bold mb-1">Password*</p>
        <v-text-field
          id="password"
          v-model="password"
          outlined
          single-line
          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show2 ? 'text' : 'password'"
          @click:append="show2 = !show2"
          :error-messages="$v.password.$error ? ['Password is required'] : []"
        ></v-text-field>
      </v-card-text>
      <v-card-text>
        <v-row>
          <v-col>
            <v-btn
              depressed
              height="45"
              block
              class="text-white" 
              color="accent"
              @click="onCancel()"
            >Cancel</v-btn>
          </v-col>
          <v-col>
            <v-btn
              depressed
              height="45"
              block
              color="primary"
              @click="confirmPw"
            >Confirm</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex"; 
import { PROFILE } from "./namespace";

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      email: localStorage.getItem("username") || "",
      password: "",
      show2: false,
      openDialogQr: false,
      urlQr: "",
      secretQr: "",
      cid: localStorage.getItem("cid") || "",
    };
  },
  validations: {
    password: { required }
  },
  methods: {
    ...mapActions(PROFILE, ["enrollNewMFA"]), 

    async confirmPw() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const payload = {
        email: this.email,
        password: this.password
      };

      try {
        const resp = await this.enrollNewMFA(payload); 
        if (resp.status === 200 && resp.data.data) {
          this.urlQr = atob(resp.data.data.url);
          this.secretQr = atob(resp.data.data.secret);
          this.$emit("sendResponse", {
            urlQr: this.urlQr,
            secretQr: this.secretQr
          });
          this.$emit("update:show", false);
        }
      } catch (err) {
        console.error("Error enrolling MFA:", err);
      }
    },

    onCancel() {
      this.$emit("update:show", false);
      this.$emit("close");
    }
  }
};
</script>

